<!--
  List | Icons, at the right end of the breadcrumb line.

  TASK-042 §5. Deliberately NOT in the folder toolbar: it changes how the pane
  is DRAWN, not what is in it, and mixing it into a set of three
  destructive-capable controls whose order was dictated by hand is how that
  order gets disturbed.

  `role="group"` with `aria-pressed` on two real buttons, rather than a
  `radiogroup` -- these are two states of one control, both always available,
  and a radio group would add arrow-key semantics to a pair of buttons for no
  gain.
-->
<script lang="ts">
  import type { PaneView } from './doclist-types'

  let { value, onchange }: { value: PaneView; onchange: (next: PaneView) => void } = $props()
</script>

<div class="switch" role="group" aria-label="How to show this folder">
  <button
    type="button"
    class="seg"
    aria-pressed={value === 'list'}
    onclick={() => onchange('list')}
  >
    List
  </button>
  <button
    type="button"
    class="seg"
    aria-pressed={value === 'icons'}
    onclick={() => onchange('icons')}
  >
    Icons
  </button>
</div>

<style>
  .switch {
    display: inline-flex;
    flex: 0 0 auto;
    border: 1px solid var(--color-line, #211d1824);
    border-radius: 0.375rem;
    overflow: hidden;
  }

  .seg {
    border: 0;
    background: transparent;
    color: var(--color-ink-soft, #6e665c);
    font: inherit;
    font-size: var(--text-meta, 0.8125rem);
    padding: 0.25rem 0.55rem;
    cursor: pointer;
  }

  .seg + .seg {
    border-left: 1px solid var(--color-line, #211d1824);
  }

  .seg:hover {
    background: var(--color-plinth, #f1ece4);
  }

  .seg[aria-pressed='true'] {
    background: var(--color-plinth, #f1ece4);
    color: var(--color-ink, #211d18);
    font-weight: 600;
  }
</style>
